import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-6 lg:mt-8" }
const _hoisted_2 = { class: "mt-20" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12" }
const _hoisted_4 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_5 = { class: "p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg" }
const _hoisted_6 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_7 = { class: "p-3 bg-purple-100 dark:bg-purple-900/30 rounded-lg" }
const _hoisted_8 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_9 = { class: "p-3 bg-red-100 dark:bg-red-900/30 rounded-lg" }
const _hoisted_10 = { class: "mt-20" }
const _hoisted_11 = { class: "flex flex-col md:flex-row gap-8 w-full mt-8" }

import { Motion } from "motion-v";


export default /*@__PURE__*/_defineComponent({
  __name: 'direct-work',
  setup(__props) {

defineOgImage("MainOg", {
  title: "Direct Work Sessions - Customizable Care Planning",
  description:
    "Track and manage direct work sessions with customizable templates. Seamlessly integrate with care plans, monitor progress, and generate comprehensive reports.",
  theme: "#bc9fff",
  colorMode: "light",
});

useSeoMeta({
  title: "Direct Work Sessions - Customizable Care Planning | FamilyAxis",
  description:
    "Track and manage direct work sessions with customizable templates. Seamlessly integrate with care plans, monitor progress, and generate comprehensive reports.",
  keywords:
    "family assessment, family assessment centres, direct work, care planning, session tracking, care templates, progress monitoring, residential care, therapeutic work",
  author: "FamilyAxis",
  ogTitle: "Direct Work Sessions - Customizable Care Planning | FamilyAxis",
  ogDescription:
    "Track and manage direct work sessions with customizable templates. Seamlessly integrate with care plans, monitor progress, and generate comprehensive reports.",
  ogUrl: "https://familyaxis.com/more/direct-work",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Direct Work Sessions - Customizable Care Planning | FamilyAxis",
  twitterDescription: "Track and manage direct work sessions with customizable templates.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

useHead({
  link: [{ rel: "canonical", href: "https://familyaxis.com/more/direct-work" }],
});

const directWorkFeatures = ref([
  {
    title: "Direct Work Analytics",
    description:
      "Gain actionable insight from notes with analytics that reveal activity levels, surface priorities, and highlight areas requiring attention.",
    video: "https://assets.familyaxis.com" + "/direct_work_analytics.mp4",
  },
  {
    title: "Document sessions",
    description:
      "Create and manage direct work sessions with flexible templates and a comprehensive text editor.",
    video: "https://assets.familyaxis.com" + "/direct_work_session.mp4",
  },
  {
    title: "Intelligent Grading System",
    description:
      "Track progress with our five-tier grading system that provides clear visual indicators of family development and intervention effectiveness.",
    video: "https://assets.familyaxis.com" + "/direct_work_grading_system.mp4",
  },
  {
    title: "Progress Overview",
    description:
      "See direct work progress on each parent's profile through a contribution calendar and a motivating animation that grows with their engagement.",
    video: "https://assets.familyaxis.com" + "/directwork_progress_overview.mp4",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_UPageHeader = _resolveComponent("UPageHeader")!
  const _component_LottieWrapper = _resolveComponent("LottieWrapper")!
  const _component_UPageSection = _resolveComponent("UPageSection")!
  const _component_LazyVideoFeatureCard = _resolveComponent("LazyVideoFeatureCard")!
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UCard = _resolveComponent("UCard")!
  const _component_LazyShowCaseCard = _resolveComponent("LazyShowCaseCard")!
  const _component_LazyStartSignup = _resolveComponent("LazyStartSignup")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "pt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHeader, {
            title: "Direct Work",
            description: "Customise and track direct work sessions with comprehensive tools for therapeutic interventions and family support."
          }),
          _createVNode(_component_UPageBody, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Motion), {
                as: "div",
                initial: { opacity: 0, y: 20 },
                "while-in-view": { opacity: 1, y: 0 },
                viewport: { once: true },
                transition: { duration: 0.4, delay: 0.15 },
                class: "mt-10"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UPageSection, {
                    id: "topFeature",
                    title: "Track and Manage Direct Work",
                    orientation: "horizontal",
                    description: "The Direct Work Hub makes it easy to log, track, and review direct work sessions - ensuring consistency and alignment with care plans.",
                    features: [
              {
                title: 'Customisable Templates',
                description:
                  'Adapt session logs to fit different types of direct work, making documentation more relevant and efficient.',
                icon: 'i-material-symbols:lock-open-outline-sharp',
              },
              {
                title: 'Seamless Integration with Reports',
                description:
                  'Logs automatically feed into weekly reports, reducing duplication and keeping assessments up to date.',
                icon: 'i-ic:baseline-sync',
              },
              {
                title: 'Progress Tracking & Insights',
                description:
                  'Identify trends, track growth, and use visual indicators to monitor goal completion over time.',
                icon: 'i-clarity:bar-chart-outline-badged',
              },
            ],
                    align: "right",
                    ui: {
              container: 'flex flex-col lg:grid py-16 sm:py-24 lg:py-5 gap-8 sm:gap-16',
            }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LottieWrapper, {
                        "animation-link": `/animations/colleague_support.json`,
                        "no-margin": true,
                        loop: true,
                        speed: 1.0,
                        scale: 1.5
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_LazyVideoFeatureCard, {
                  "section-title": "Create and manage direct work sessions",
                  "section-description": "Our platform makes it easy to plan, execute, and document direct work sessions, ensuring consistency and alignment with your care plans.",
                  features: _unref(directWorkFeatures),
                  orientation: "right"
                }, null, 8, ["features"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_UPageHero, {
                  title: "Comprehensive Direct Work Features",
                  description: "Everything you need to plan, execute, and document effective direct work sessions.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
            }
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.1 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-clipboard-document-list",
                                class: "h-6 w-6 text-blue-600 dark:text-blue-400"
                              })
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Session Planning", -1))
                          ]),
                          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Plan structured sessions with clear objectives, activities, and expected outcomes tailored to each family's needs. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.3 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-document-text",
                                class: "h-6 w-6 text-purple-600 dark:text-purple-400"
                              })
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Automated Reports", -1))
                          ]),
                          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Generate comprehensive reports automatically from your session logs, saving time and ensuring consistency in documentation. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.5 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-shield-check",
                                class: "h-6 w-6 text-red-600 dark:text-red-400"
                              })
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Compliance Ready", -1))
                          ]),
                          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Meet regulatory requirements with standardised documentation and audit trails that ensure full compliance with care standards. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_UPageHero, {
                  title: "Continue Your Journey",
                  description: "Explore more tools that work seamlessly with Direct Work to enable you to run your organisation with ease.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
            }
                }),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_LazyShowCaseCard, {
                    title: "Progress & Observations",
                    description: "Log observations and track progress against assessment goals with comprehensive monitoring tools.",
                    icon: "i-heroicons-chart-bar-square",
                    image: "/images/obs_track.svg",
                    "image-position": "bottom",
                    link: "/more/progress-observations",
                    class: "w-full md:w-4/7 h-110"
                  }),
                  _createVNode(_component_LazyShowCaseCard, {
                    title: "Tasks & Collaboration",
                    description: "Assign tasks, share updates, and work together seamlessly across your organization.",
                    icon: "i-heroicons-user-group",
                    image: "/images/tasks_preview.svg",
                    "image-position": "right",
                    link: "/more/team-collaboration",
                    class: "w-full md:w-3/7 h-110"
                  })
                ])
              ]),
              _createVNode(_component_LazyStartSignup)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})